import React from "react";
import { Alert, Badge, Card, Col, Row } from "react-bootstrap";
import { formatAngka, formatDelta, formatRupiah } from "../../utils";

const rupiah = (n) =>
  n === null || n === undefined || isNaN(Number(n))
    ? "-"
    : formatRupiah(String(Math.round(Number(n))), "Rp ");

function PanelEfisiensi({ items, efisiensi }) {
  const rewash = efisiensi?.rewash;
  // Endpoint efisiensi mengirim baris Period_Impact mentah tanpa nama indikator,
  // jadi nama diambil dari panel dashboard bila kodenya cocok.
  const daftar =
    items && items.length > 0
      ? items
      : (efisiensi?.indikator || []).map((val) => ({
          code: val.indicator_code,
          nama: val.indicator_code,
          unit: "",
          total: val.total,
          intensity: val.intensity,
          order_count: val.order_count,
          delta_vs_prev: val.delta_vs_prev,
          quality_tier: val.quality_tier,
        }));

  return (
    <div>
      <div className="table-responsive mb-3">
        <table
          className="table table-bordered align-middle mb-0"
          style={{ fontSize: "12px" }}
        >
          <thead className="table-light">
            <tr>
              <th>Indikator Efisiensi</th>
              <th className="text-end">Nilai</th>
              <th className="text-end">Intensitas</th>
              <th className="text-end">Order</th>
              <th className="text-end">Δ vs lalu</th>
              <th className="text-center">Tier</th>
            </tr>
          </thead>
          <tbody>
            {daftar.length > 0 ? (
              daftar.map((val) => (
                <tr key={val.code}>
                  <td>
                    {val.nama}
                    <div className="text-muted" style={{ fontSize: "10px" }}>
                      {val.code}
                    </div>
                  </td>
                  <td className="text-end">
                    {formatAngka(val.total)} {val.unit}
                  </td>
                  <td className="text-end">{formatAngka(val.intensity, 4)}</td>
                  <td className="text-end">{formatAngka(val.order_count, 0)}</td>
                  <td className="text-end">{formatDelta(val.delta_vs_prev)}</td>
                  <td className="text-center">
                    <Badge bg="secondary">{val.quality_tier || "-"}</Badge>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={6} align="center">
                  Data tidak ditemukan
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {rewash && (
        <Row className="g-2">
          <Col xs={12} lg={6}>
            <Card className="h-100 border-0 shadow-sm">
              <Card.Body className="p-3">
                <div className="fw-bold mb-2" style={{ fontSize: "13px" }}>
                  Rewash
                </div>
                <div style={{ fontSize: "12px" }}>
                  <div className="d-flex justify-content-between">
                    <span className="text-muted">Rate</span>
                    <span className="fw-bold">
                      {formatAngka(rewash.rate_persen)}%
                    </span>
                  </div>
                  <div className="d-flex justify-content-between">
                    <span className="text-muted">Jumlah kejadian</span>
                    <span>{formatAngka(rewash.jumlah_kejadian, 0)}</span>
                  </div>
                  <div className="d-flex justify-content-between">
                    <span className="text-muted">Order terdampak</span>
                    <span>
                      {formatAngka(rewash.order_terdampak, 0)} dari{" "}
                      {formatAngka(rewash.total_order, 0)}
                    </span>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={12} lg={6}>
            <Card className="h-100 border-0 shadow-sm">
              <Card.Body className="p-3">
                <div className="fw-bold mb-2" style={{ fontSize: "13px" }}>
                  Sumber daya terbuang akibat rewash
                </div>
                <table className="table table-sm mb-2" style={{ fontSize: "12px" }}>
                  <tbody>
                    {(rewash.konsumsi_terbuang || []).map((val) => (
                      <tr key={val.indicator_code}>
                        <td className="text-muted">{val.indicator_code}</td>
                        <td className="text-end">
                          {formatAngka(val.quantity)} {val.unit}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className="d-flex justify-content-between align-items-center">
                  <span className="text-muted" style={{ fontSize: "12px" }}>
                    Estimasi kerugian
                  </span>
                  <span className="fw-bold text-danger" style={{ fontSize: "16px" }}>
                    {rupiah(rewash.estimasi_kerugian_rupiah)}
                  </span>
                </div>
                {rewash.catatan && (
                  <Alert variant="warning" className="mt-2 mb-0 py-1 px-2" style={{ fontSize: "11px" }}>
                    {rewash.catatan}
                  </Alert>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}
    </div>
  );
}

export default PanelEfisiensi;
